var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTextComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.85 6.66003H7.14004C6.60004 6.66003 6.17004 7.10003 6.17004 7.63003V13.46C6.17004 14 6.60004 14.43 7.14004 14.43H11.51V18.65L13.68 14.88L13.94 14.43H16.85C17.39 14.43 17.82 14 17.82 13.46V7.63003C17.82 7.10003 17.39 6.66003 16.85 6.66003ZM12.97 12.49H8.11004V11.52H12.97V12.49ZM15.88 9.58003H8.11004V8.60003H15.88V9.58003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTextComment);
export default __webpack_public_path__ + "static/media/ic-text-comment.fad70835af43477faafdb11627894076.svg";
export { ForwardRef as ReactComponent };